import moment from 'moment';

const dayFormatType = {
  // 接口参数格式
  APIPARAMS: 'YYYY-MM-DDTHH:mm:ssZ',
  DATAPARAMS: 'YYYY-MM-DDT00:00:00',
  FILTERPARAMS: 'YYYY-MM-DD',
  // Month name, day of month, year
  MDY: 'll',
  // UK时间格式
  UKFORMAT: 'DD/MM/YYYY',
  // UK 仅显示月份
  UKWITHMONTH: 'MM/YYYY',
  // 时分 UK时间格式
  UKWITHHM: 'DD/MM/YYYY HH:mm',
  // 时分秒 UK时间格式
  UKWITHHMS: 'DD/MM/YYYY HH:mm:ss',
  // UK时间格式 凌晨
  UKZERO: 'DD/MM/YYYY 00:00:00',
  // 面板卡时间格式
  CONTENTDATE: 'DD MMM YYYY',
  // Room Detail面板显示日期格式 "Aug,2021"
  DETAILDATE: 'MMM,YYYY',
  // booking table
  BOOKINGTABLE: 'MMM DD, YYYY',
  UTC: 'YYYY-MM-DD HH:mm UTC',
};

// 校验日期有效性
const validateDay = date => {
  return date && moment(date).isValid();
};

// 格式化日期
const formatDay = (type, date) => {
  const isValid = validateDay(date);
  if (isValid) {
    return moment(date).format(type);
  }
  return moment().format(type);
};

// 获取时间戳
const getTimestamp = date => {
  const isValid = validateDay(date);
  if (isValid) {
    return moment(date).valueOf();
  }
  return moment().valueOf();
};

// 判断目标日期是否大于指定日期
const isAfter = (target, date) => {
  const isValid = validateDay(date);
  if (isValid) {
    return moment(date).isAfter(moment(target));
  }
  return moment().isAfter(moment(target));
};

// 判断目标日期是否小于指定日期
const isBefore = (target, date) => {
  const isValid = validateDay(date);
  if (isValid) {
    return moment(date).isBefore(moment(target));
  }
  return moment().isBefore(moment(target));
};

// 获取两个日期之间时间的差值
// return {
//   days: 26
//   hours: 1
//   milliseconds: 437
//   minutes: 58
//   months: 11
//   seconds: 33
//   years: 0
//  }
const dateDuration = (start, end) => {
  const isValid = validateDay(start) && validateDay(end);
  if (isValid) {
    return moment.duration(moment(end).diff(moment(start)));
  }
};

const calcTenancyLength = (t, moveIn, moveOut) => {
  const diffDate = moment(moveOut).diff(moment(moveIn), 'days');

  let tenancyDesc = '';
  if (diffDate > 0) {
    if (diffDate < 7) {
      tenancyDesc = t('landlord.longtail_enquiry.property_card.only_days.tenancy_desc', {
        days: diffDate % 7,
      });
    } else if (diffDate % 7) {
      tenancyDesc = t('landlord.longtail_enquiry.property_card.have_days.tenancy_desc', {
        weeks: Math.floor(diffDate / 7),
        days: diffDate % 7,
      });
    } else {
      tenancyDesc = t('landlord.longtail_enquiry.property_card.only_weeks.tenancy_desc', {
        weeks: diffDate / 7,
      });
    }
  }
  return tenancyDesc;
};

export {
  validateDay,
  dayFormatType,
  formatDay,
  getTimestamp,
  isAfter,
  isBefore,
  moment,
  dateDuration,
  calcTenancyLength,
};
